import React from "react";
import { Star } from "@phosphor-icons/react";

export default function StarRating({ value = 0, size = 16, interactive = false, onChange, testId = "star-rating" }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-0.5" data-testid={testId}>
      {stars.map((n) => {
        const filled = value >= n;
        const half = !filled && value >= n - 0.5;
        return (
          <button
            key={n}
            type="button"
            disabled={!interactive}
            onClick={() => interactive && onChange && onChange(n)}
            className={`${interactive ? "cursor-pointer hover:scale-110" : "cursor-default"} transition-transform`}
            data-testid={`${testId}-star-${n}`}
          >
            <Star
              size={size}
              weight={filled || half ? "fill" : "regular"}
              className={filled || half ? "text-[#FFB800]" : "text-zinc-700"}
            />
          </button>
        );
      })}
    </div>
  );
}
